module.exports = __webpack_public_path__ + "img/medal4.ff0a3e8a.png";